import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as CurrenciesThunks from '../../../../store/currencies/thunks';

const CurrencySelector = ({ currentCurrency, currencies }) => {
  const dispatch  = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const wrapRef = useRef(null);

  const handleChangeCurrency = code => {
    dispatch(CurrenciesThunks.setCurrency(code));
    setIsOpen(false);
    setSearch('');
  };

  useEffect(() => {
    const onOutside = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', onOutside);
    return () => document.removeEventListener('mousedown', onOutside);
  }, []);

  const filtered = (currencies || []).filter(c =>
    !search ||
    c.code.toLowerCase().includes(search.toLowerCase()) ||
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  if (!currentCurrency || !currencies) return null;

  return (
    <div id="currency-selector" className={isOpen ? 'open' : ''} ref={wrapRef}>
      <button id="currency-trigger" onClick={() => setIsOpen(!isOpen)}>
        {currentCurrency.code} <span className="curr-arrow">▼</span>
      </button>
      {isOpen && (
        <div id="currency-dropdown">
          <div className="curr-search-wrap">
            <input
              type="text"
              id="curr-search"
              placeholder="🔍"
              autoComplete="off"
              value={search}
              onChange={e => setSearch(e.target.value)}
              autoFocus
            />
          </div>
          <div className="curr-list">
            {filtered.map(c => (
              <button
                key={c.code}
                className={c.code === currentCurrency.code ? 'active' : ''}
                onClick={() => handleChangeCurrency(c.code)}
              >
                <span className="curr-code">{c.code}</span>
                <span className="curr-name">{c.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

CurrencySelector.propTypes = {
  currentCurrency: PropTypes.object.isRequired,
  currencies: PropTypes.array.isRequired,
};

export default CurrencySelector;
